angular
  .module('contrast.chart', [])
  .controller(
    'ChartCtrl',
    function ($scope, $uibModalInstance, $timeout, chartParameters) {
      var chart = {
        data: chartParameters.data,
        options: chartParameters.options
      }
      $scope.container = chartParameters.legendContainer
      $scope.chartTitle = chartParameters.title
      $scope.hasData = chartParameters.data.length > 0

      $timeout(function () {
        $scope.chart = chart
      })

      $scope.close = function () {
        $uibModalInstance.dismiss()
      }
    }
  )
